{
	"content": {
		"declarationDetailsSection": {
			"title": "Détails de la déclaration",
			"description": "Pour créer la déclaration, le nom, l’adresse et le pays du titulaire de la déclaration sont nécessaires. Ces informations ne peuvent pas être modifiées par la suite.",
			"customerLabel": "Compte client"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Fournir les détails de la déclaration",
			"alertDescription": "Les informations que vous fournissez seront enregistrées de manière permanente sur la déclaration et ne pourront pas être modifiées par la suite.",
			"projectLabel": "Référence du projet",
			"companyNameLabel": "Nom de l’entreprise",
			"streetLabel": "Rue",
			"zipCodeLabel": "Code postal",
			"cityLabel": "Ville",
			"countryLabel": "Pays"
		}
	},
	"summary": {
		"title": "Récapitulatif",
		"declarationTypeTitle": "Type de déclaration",
		"customerProjectTitle": "Projet client",
		"internalProjectOrProductTitle": "Projet / produit interne",
		"projectReferenceTitle": "Référence du projet",
		"materialHeaderTitle": "Matériau",
		"quantityHeaderTitle": "Quantité ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Réductions de carbone allouables ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Réduction de carbone non allouable ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "La référence du projet est requise",
		"companyNameRequired": "Le nom de l’entreprise est requis",
		"streetRequired": "La rue est requise",
		"zipCodeRequired": "Le code postal est requis",
		"cityRequired": "La ville est requise",
		"countryRequired": "Le pays est requis",
		"customerRequired": "Le client est requis"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Vérifier le résumé de la déclaration",
		"description": "Veuillez vérifier les données que vous avez saisies afin de corriger toute erreur.",
		"alertDescription": "Les informations que vous avez fournies seront enregistrées de manière permanente sur la déclaration et ne pourront pas être modifiées par la suite.",
		"typeSectionTitle": "1. Type",
		"declarationTypeLabel": "Type de déclaration",
		"customerProjectTitle": "Projet client",
		"internalProjectOrProductTitle": "Projet / produit interne",
		"projectReferenceLabel": "Référence du projet",
		"materialSectionTitle": "2. Matériau",
		"materialHeaderTitle": "Matériau",
		"quantityHeaderTitle": "Quantité ({{unit}})",
		"totalCarbonReductionsLabel": "Réductions totales de carbone ({{unit}})",
		"declarationSectionTitle": "3. Déclaration",
		"companyNameLabel": "Nom de l’entreprise",
		"streetLabel": "Rue",
		"zipCodeLabel": "Code postal",
		"cityLabel": "Ville",
		"countryLabel": "Pays",
		"backTitle": "Retour",
		"submitTitle": "Oui, tout est correct"
	},
	"submitTitle": "Créer la déclaration",
	"backTitle": "Retour"
}
